/**
 * default prefix "DRIVE_DOCS"
*/

export const AT_SET = 'DRIVE_DOCS_SET';
export const AT_DELETE = 'DRIVE_DOCS_DELETE';
export const AT_UPDATE_DRIVE_DOC = 'DRIVE_DOCS_UPDATE_DRIVE_DOC';
